/** Дефолт и лимит блуждающих ботов (одиночка + P2P-хост). */
export const MYSTERY_ROOM_DEFAULT_WANDER_BOTS = 3;
export const MYSTERY_ROOM_MAX_WANDER_BOTS = 7;

export function clampWanderBotCount(value: number): number {
  if (!Number.isFinite(value)) return MYSTERY_ROOM_DEFAULT_WANDER_BOTS;
  return Math.min(MYSTERY_ROOM_MAX_WANDER_BOTS, Math.max(0, Math.floor(value)));
}
